import LegalDocView from '../components/LegalDocView'
import { useSeoHead } from '../lib/seo'
import { pagePath } from '../lib/localizedUrl'

export default function TermsPage() {
  useSeoHead({
    title: 'Obchodní podmínky | SEO Tools',
    description: 'Obchodní podmínky služby SEO Tools — práva a povinnosti, platby a předplatné, odstoupení od smlouvy a reklamace.',
    hreflangPath: (l) => pagePath('terms', l),
  })
  return <LegalDocView doc="terms" />
}
